'use strict';

import { tns } from "tiny-slider/src/tiny-slider";
import Timeline from "../anims/timeline";

var timelineTimer;

const changeNews = function (index) {
    // switch slide
    document.querySelector('.mainSlide_1.photos .tns-nav button[data-nav="' + index + '"]').click();
    if(index === 0) {
        hpSlider.int = 0;
        hpSlider.part = 0;
    }
    document.querySelector('.mainSlide_1.photos .playBtn').click();
};

const hpSlider = {
    timeline: new Timeline('#timeline1', changeNews),
    int: 0,
    part: 0,

    init: function () {
        hpSlider.slider();
    },

    slider: function() {
        if (document.querySelector('.mainSlide_subSlider')) {
            let hp_slider = tns({
                container: '.mainSlide_subSlider',
                mode: "carousel",
                items: 1,
                autoplay: true,
                mouseDrag: false,
                controls: false,
                nav: true,
                autoplayButton: false,
                autoplayButton: false,
                autoplayText: '',
                speed: 500,
                loop: true,
            });
            
            document.querySelector('.mainSlide_1.photos .playBtn').addEventListener('click', function() {
                hp_slider.play();
            });
            // when slider is init
            hpSlider.setTimeline(hpSlider.int, hpSlider.part);

            // when slider index change
            hp_slider.events.on('indexChanged', function(index) {
                clearInterval(timelineTimer);
                if( index.index === 5) {
                    hpSlider.int = 0;
                    hpSlider.part = 0;
                } else if (index.index === 1) {
                    hpSlider.part = 0;
                } else {
                    hpSlider.int = 0;
                    hpSlider.part = index.index - 1;
                }
                hpSlider.setTimeline(hpSlider.int, hpSlider.part);
            });
        }
    },

    setTimeline: function() {
        let videoPart = hpSlider.part * 25;
        timelineTimer = setInterval(function () {
            hpSlider.int = hpSlider.int + .25;
            let percentBar = hpSlider.int + videoPart;
            if (videoPart + 25 >= percentBar) {
                hpSlider.timeline.updateTimer(percentBar);
            }
        }, 50);
    }
    
};

export default hpSlider;


// WEBPACK FOOTER //
// ./src/scripts/components/hpSlider.js